export default __webpack_public_path__ + "static/media/okletsplayLoading.f68773e0.gif";